import {
  EventType,
  SearchIntent,
  VERSION,
  WIDGET_TYPE,
} from '../types/constants';
import { kyPost } from './post-request';
import { Logger } from './logger';

const fingerprint: string = 'NO_FINGERPRINT';
interface IEventTrackerProps {
  apiHost: string;
  apiKey: string;
  source: WIDGET_TYPE;
  skip?: boolean;
  accessToken?: string;
}

export interface ITrackPropsData {
  searchQueryId?: string;
  searchQuery?: string;
  promptId?: string;
  answer?: string;
  category?: string;
  categoryId?: string;
  widgetVersion?: string;
  widgetKey?: string;
  action?: string;
  fingerprint?: string;
  domain?: string;
  properties?: unknown;
  browserLanguage?: string;
  source?: string;
  searchIntent?: SearchIntent;
  intentActionClicked?: {
    id: string;
    type: string;
  };
}

export interface ITrackProps {
  type: EventType; // maps to a list of event names mapped in Platform. https://github.com/brainfish-ai/brainfish/blob/main/server/utils/tracking/%40types/mixpanel.ts
  name: string; // maps to actionType in mixpanel
  data: ITrackPropsData;
}
export const getEventTracker = async ({
  apiHost,
  apiKey,
  source,
  skip,
  accessToken,
}: IEventTrackerProps) => {
  const track = async ({ type, name, data }: ITrackProps) => {
    // Calculate unixTimestamp just before the fetch call
    const unixTimestamp = Date.now() / 1000;
    const trackBody = {
      type,
      name,
      data: {
        widgetVersion: VERSION,
        widgetKey: apiKey,
        action: name,
        searchQueryId: data.searchQueryId,
        searchQuery: data.searchQuery,
        promptId: data.promptId,
        answer: data.answer,
        fingerprint,
        domain: window.location.host,
        properties: { time: unixTimestamp },
        browserLanguage: navigator.language,
        source: `${source} Widget`,
        searchIntent: data.searchIntent,
        intentActionClicked: data.intentActionClicked,
      } satisfies ITrackPropsData,
    } satisfies ITrackProps;

    // skip tracking, just log in console
    if (skip) {
      Logger.info('track', { trackBody });

      return;
    }

    try {
      // Track with BrainfishAnalytics
      if (window.BrainfishAnalytics) {
        const eventName = trackBody.type;
        // omit answer from data before sending
        const cleanedData = { ...trackBody.data };
        delete cleanedData.answer;
        window.BrainfishAnalytics('track', eventName, cleanedData);
      }

      // use Authorization header if accessToken is provided
      // otherwise use api-key header
      await kyPost({
        endpoint: `${apiHost}/api/trackEvents.widget.create`,
        requestBody: trackBody,
        apiKey,
        accessToken,
      });
    } catch (e) {
      Logger.error('Failed to track', e as Error, {
        widgetKey: apiKey,
        version: VERSION,
        function: 'track',
        filename: 'trackEvent.ts',
      });
    }
  };

  return { track, apiHost, apiKey, source };
};
